import { LoadMoreButton } from 'components/LoadMoreButton';
import { MostFeaturedPost } from 'components/MostFeaturedPost';
import { DownloadApp } from 'components/News/DownloadApp';
import { useFetchDataByPage } from 'hooks/useFetchDataByPage';
import { useRouter } from 'next/router';
import React, { useCallback, useState } from 'react';
import { useSearchParam } from 'react-use';
import { axiosInstance } from 'services/axios';
import { BlogType } from 'types';

import { BasePath } from '../../constants/basePath';
import { BlogCard } from './BlogCard';

interface Props {
  topBlog: BlogType;
  blogs: BlogType[];
  totalCountBlogs: number;
}

const DEFAULT_LIMIT = 6;

export const ListBlog: React.FC<Props> = ({
  blogs,
  topBlog,
  totalCountBlogs
}) => {
  const [page, setPage] = useState(+useSearchParam('page') || 1);
  const [allBlogs, setAllBlogs] = useState<BlogType[]>(blogs);
  const [loading, setLoading] = useState<boolean>(false);
  const shouldShowGetMoreButton = page * DEFAULT_LIMIT < totalCountBlogs;
  const router = useRouter();

  const fetchBlogs = useCallback(
    async (page: number, limit: number) => {
      const apiUrl = '/api/blogs';
      const payload = {
        topBlogId: topBlog.id,
        page,
        limit
      };
      try {
        const { data } = await axiosInstance.post(apiUrl, payload);
        return data.blogs;
      } catch (error) {
        console.log(error);
      }
    },
    [topBlog.id]
  );

  useFetchDataByPage(DEFAULT_LIMIT, fetchBlogs, setAllBlogs);

  const handleGetMoreEvents = async () => {
    setLoading(true);
    try {
      const data = await fetchBlogs(page + 1, DEFAULT_LIMIT);
      const newBlogs = [...allBlogs, ...data];
      setAllBlogs(newBlogs);
      setPage(page + 1);
      router.replace(
        {
          query: { ...router.query, page: page + 1 }
        },
        undefined,
        { shallow: true }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative w-full flex flex-col justify-center items-center mt-[64px]">
      <div
        style={{
          background:
            'linear-gradient(180deg, #FCF3F3 0%, rgba(252, 243, 243, 0.00) 125.12%)',
          borderRadius: '0px 400px 0px 0px'
        }}
        className="-z-10 absolute left-0 top-0 w-2/3 lg:w-10/12 h-[486px] lg:h-[600px]"
      />
      <div>
        <img
          src="/svg/blog-decoration.svg"
          alt="blog-decoration"
          className="-z-10 absolute lg:top-[20px] right-0 xl:right-[80px]"
        />
      </div>
      <div className="w-full text-center my-8">
        <h4 className="text-3xl font-bold">Blog</h4>
        <h5 className="mt-2 text-gray-700 text-sm font-normal px-4 lg:px-0">
          Đây là những bài viết giúp bạn phát triển <br className="lg:hidden" />{' '}
          sự nghiệp trong bất kỳ lĩnh vực nào
        </h5>
      </div>
      <div className="w-full xl:w-[1280px] flex justify-center">
        <MostFeaturedPost topPost={topBlog} basePath={BasePath.BlogsBasePath} />
      </div>
      <div className="w-full xl:w-[1280px] px-4 md:px-[40px] xl:px-[80px]">
        <div className="grid grid-cols-1 md:grid-cols-9 gap-y-10 gap-x-6">
          {allBlogs.map(blog => (
            <div key={blog.id} className="col-span-1 md:col-span-3">
              <BlogCard blog={blog} />
            </div>
          ))}
        </div>
        {shouldShowGetMoreButton && (
          <div className="flex justify-center mt-[40px]">
            <LoadMoreButton
              loading={loading}
              onClick={handleGetMoreEvents}
              dataTestId="get-more-blogs-button"
            />
          </div>
        )}
      </div>
      <DownloadApp />
    </div>
  );
};
